var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import { AlertSuccess, AlertWarning, } from "../../UI/StandardAlerts/StandardAlerts";
import useUniqueId from "../../Hooks/useUniqueId";
import PipelineService from "../../../Services/Pipeline.service";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import { PersonTypeContext } from "../../Hooks/usePersonType";
import PipelineStatusDomainService from "../../../Domain/PipelineStatus/PipelineStatus.service";
import ManuallyAddToPipelineForm, { getPipelineEnrollPopulationRequest, } from "../Opportunity/ManuallyAddToPipelineForm";
const PipelineToPopulationModal = (_a) => {
    var _b, _c;
    var { populationId, populationName, numStudentsReturnedByPopulation } = _a, modalProps = __rest(_a, ["populationId", "populationName", "numStudentsReturnedByPopulation"]);
    const [applicablePipelines, loadApplicablePipelines] = useService(PipelineService.search);
    const virtualizedAppContext = useVirtualizedApp();
    const personTypeContext = React.useContext(PersonTypeContext);
    React.useEffect(() => {
        loadApplicablePipelines({
            virtualizedAppName: virtualizedAppContext.name,
            pipelineStatusIds: [PipelineStatusDomainService.ActiveId],
            personTypeName: personTypeContext.internalName,
        }, { max: 1 });
    }, [
        loadApplicablePipelines,
        personTypeContext.internalName,
        virtualizedAppContext.name,
    ]);
    const makeId = useUniqueId()[1];
    const noPipelines = !((_c = (_b = applicablePipelines.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Create Opportunities in Pipeline", handleSubmit: (request) => noPipelines
            ? Promise.resolve()
            : PipelineService.enrollPopulation(getPipelineEnrollPopulationRequest(request, populationId)), saveButtonContents: noPipelines ? "Ok" : undefined, keepModalOpenAfterSuccess: noPipelines ? (false) : (_jsx(AlertSuccess, { message: _jsxs("span", { children: ["Opportunities successfully created for ", _jsx("b", { children: populationName }), numStudentsReturnedByPopulation != null
                        ? `, which has ${numStudentsReturnedByPopulation === 1
                            ? "1 person"
                            : `${numStudentsReturnedByPopulation} people`}.  Opportunities were not created for people already in the pipeline`
                        : "."] }) })), children: _jsx(ServiceResult, { state: applicablePipelines, children: ({ data }) => data.length > 0 ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("filterLabel"), children: "Filter" }), _jsxs("div", { id: makeId("filterLabel"), children: [populationName, " ", numStudentsReturnedByPopulation != null &&
                                        `(${numStudentsReturnedByPopulation})`] })] }), _jsx(ManuallyAddToPipelineForm, {}), _jsx(AlertWarning, { message: "People already in the pipeline will not be added a second time." })] })) : (_jsx("div", { children: "There are no applicable pipelines. Please ensure that an active pipeline has been created within this app and for this person type." })) }) })));
};
export default PipelineToPopulationModal;
